import { STORAGE_KEYS } from "./constants";

export function getAccessToken() {
  return localStorage.getItem(STORAGE_KEYS.accessToken);
}

export function setAccessToken(token) {
  if (!token) {
    localStorage.removeItem(STORAGE_KEYS.accessToken);
    return;
  }

  localStorage.setItem(STORAGE_KEYS.accessToken, token);
}

export function getRefreshToken() {
  return localStorage.getItem(STORAGE_KEYS.refreshToken);
}

export function setRefreshToken(token) {
  if (!token) {
    localStorage.removeItem(STORAGE_KEYS.refreshToken);
    return;
  }

  localStorage.setItem(STORAGE_KEYS.refreshToken, token);
}

export function clearTokens() {
  localStorage.removeItem(STORAGE_KEYS.accessToken);
  localStorage.removeItem(STORAGE_KEYS.refreshToken);
}
